module.exports = [{"value":0,"label":"请选择"},{"value":1,"label":"微信"},{"value":2,"label":"支付宝"},{"value":3,"label":"储值卡"},{"value":4,"label":"线上"},{"value":5,"label":"贵宾券"},{"value":6,"label":"会员票"},{"value":7,"label":"影院联票"},{"value":8,"label":"玩乐园套票"}]


//////////////////
// WEBPACK FOOTER
// ./src/assets/js/payment_methodagent.json
// module id = 4m6E
// module chunks = 1